Shopify.MobileMenu = {};

Shopify.MobileMenu = function(container){
  this.container = document.querySelector('#menu-drawer');

  // this.mobileMenuContainer = this.container.querySelector('.mobile-menu-inner');

  this.fetchSection('/?view=sections&sections=header',container);

};

Shopify.MobileMenu.prototype = {

  fetchSection: function(sectionUrl,container){
    var self = this;

    var pageUrl = window.location.hostname;
    pageUrl = pageUrl.split('?')[0];

    fetch('https://' + pageUrl + sectionUrl).then(function (response) {
      return response.text();
    }).then(function (data) {
      var parser = new DOMParser();
      var results = JSON.parse(data);
      var docElement = parser.parseFromString(results['header'], 'text/html');
      self.appendMenus(docElement);
      

    }).catch(function (err) {
      console.warn('Something went wrong.', err);
    });
  },

  appendMenus: function(sectionHtml){
    var self = this;
    var mobileMenu = sectionHtml.querySelector('.js-mobile-menu');
    self.container.innerHTML = mobileMenu.innerHTML;
    customElements.define('header-drawer', HeaderDrawer);
    
    function openMobileHelpMenu() {
      document.body.classList.toggle('help-menu-open')
      document.getElementById('footer-title-arrow').classList.toggle('rotate-footer');
    }
    document.getElementById('footer-title-first').addEventListener('click', openMobileHelpMenu)
    document.getElementById('Top-navigation-mobile-help-close').addEventListener('click', openMobileHelpMenu)
  },

};


class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.querySelector('html').classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.querySelector('.logo-1').style.display = 'block';
    document.querySelector('.logo-2').style.display = 'none';
  }
}



new Shopify.MobileMenu();

